<div data-spartan-page
     class="p-6 md:p-8 space-y-5"
     style="background: rgb(var(--ds-bg, 250 250 249)); min-height: 100%;">

  <div class="rounded-lg border border-border bg-card shadow-sm p-10 max-w-md mx-auto text-center">
    <div class="w-14 h-14 rounded-full bg-ds-accent-light flex items-center justify-center mx-auto mb-5">
      <svg xmlns="http://www.w3.org/2000/svg" class="size-7 text-ds-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
      </svg>
    </div>

    <h1 class="text-xl font-semibold tracking-tight mb-1">Inquiry Form</h1>
    <p class="text-xs font-semibold uppercase tracking-[0.08em] text-ds-accent mb-3">Phase 1C/D — Coming Soon</p>
    <p class="text-sm text-muted-foreground leading-relaxed mb-8">
      The Inquiry Form is being built as part of the Forwarding UX overhaul.
      It will be available in Phase 1C/D of the Forwarding Admin migration.
    </p>

    <a routerLink="/dashboard/forwarding/inquiries">
      <button class="inline-flex items-center gap-2 h-9 px-4 rounded-md border border-input bg-background text-sm font-medium shadow-xs hover:bg-accent hover:text-accent-foreground transition-colors">
        Back to Inquiries
      </button>
    </a>
  </div>

</div>
